import { IconProps } from '@euler/app/components/icons/types';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { FC, memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const QuoteIcon: FC<IconProps> = memo(
  ({ size, width, height, fill = '#ddd', ...props }) => {
    const { rpx } = useResponsiveContext();
    size = size ?? rpx(64);
    return (
      <Svg
        viewBox="0 0 1102 1024"
        width={width ?? size}
        height={height ?? size}
        fill="none"
        {...props}
      >
        <Path
          d="M372.889203 184.276641c-169.100917 70.097389-297.010586 266.659139-297.010586 446.599859 0 126.464361 84.550459 211.01482 198.007057 211.01482 87.441073 0 177.772759-75.878617 177.772759-174.159492 0-123.573747-110.565984-185.721948-203.788285-171.268878C273.885674 375.057163 338.201835 290.506704 425.642908 245.702188l-52.753705-61.425547z m498.63091 0c-169.100917 70.097389-297.010586 266.659139-297.010586 446.599859 0 126.464361 84.550459 211.01482 198.007057 211.01482 87.441073 0 177.772759-75.878617 177.77276-174.159492 0-123.573747-110.565984-185.721948-203.788285-171.268878 26.015526-120.683133 90.331687-205.233592 177.772759-250.038109l-52.753705-62.1482z"
          fill={fill}
        />
      </Svg>
    );
  },
);
